import { render } from "./NewTableViewModal.vue?vue&type=template&id=60e2556a"
import script from "./NewTableViewModal.vue?vue&type=script&lang=js"
export * from "./NewTableViewModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__